"use client";
import { useState, useEffect } from 'react';
import { StudioCanvasMode } from '@contentful/experiences-core/constants';

const useFetchByBase = (fetchMethod, mode) => {
    const [experience, setExperience] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState();
    useEffect(() => {
        (async () => {
            // if we are in editor/read only mode, we don't want to fetch the experience here
            // it is passed via postMessage instead
            if (mode === StudioCanvasMode.EDITOR || mode === StudioCanvasMode.READ_ONLY) {
                return;
            }
            setIsLoading(true);
            setError(undefined);
            try {
                const exp = await fetchMethod();
                setExperience(exp);
            }
            catch (error) {
                setError(error);
            }
            finally {
                setIsLoading(false);
            }
        })();
    }, [fetchMethod, mode]);
    // When a save event caused a canvas reload, the `receivedModeMessage` might time out and set the
    // mode temporarily to NONE. If it's set to a valid mode afterward, we ignore the fetch result.
    if (mode === StudioCanvasMode.EDITOR || mode === StudioCanvasMode.READ_ONLY) {
        return {
            error: undefined,
            experience: undefined,
            isLoading: false,
            mode,
        };
    }
    return {
        error,
        experience,
        isLoading,
        mode,
    };
};

export { useFetchByBase };
//# sourceMappingURL=useFetchByBase.js.map
